import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frequency", "amount", "totalWeight"];

  connect() {
    this.updateTotalWeight();
  }

  updateTotalWeight() {
    const frequency = parseFloat(this.frequencyTarget.value) || 0;
    const amount = parseFloat(this.amountTarget.value) || 0;
    const totalWeight = frequency * amount;

    if (totalWeight > 0) {
      this.totalWeightTarget.textContent = totalWeight;
    } else {
      this.totalWeightTarget.textContent = 0;
    }
  }
}
